import { useContext, useEffect } from 'react';

//context
import { SpotlightContext } from '@/context/SpotlightContext';



export const useLatestFromThrive = () => {
    const {spotlightData, spotlightItem, getSpotlight, isLoading} = useContext(SpotlightContext);

    useEffect(() => {
        getSpotlight();
    }, []);

    return { spotlightData, spotlightItem, isLoading };
};